import { render, staticRenderFns } from "./EventTextOnly.vue?vue&type=template&id=354a7689&scoped=true"
import script from "./EventTextOnly.vue?vue&type=script&lang=js"
export * from "./EventTextOnly.vue?vue&type=script&lang=js"
import style0 from "./EventTextOnly.vue?vue&type=style&index=0&id=354a7689&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354a7689",
  null
  
)

export default component.exports